/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function DeviceMobile(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M176,16H80A24.0275,24.0275,0,0,0,56,40V216a24.0275,24.0275,0,0,0,24,24h96a24.0275,24.0275,0,0,0,24-24V40A24.0275,24.0275,0,0,0,176,16ZM80,32h96a8.00917,8.00917,0,0,1,8,8v8H72V40A8.00917,8.00917,0,0,1,80,32Zm96,192H80a8.00917,8.00917,0,0,1-8-8v-8H184v8A8.00917,8.00917,0,0,1,176,224Z" />
    </Svg>
  );
}

export default DeviceMobile;
